import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/fsk/banner_back.webp";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Banner() {
  return (
    <div className="banner_fsk" style={{ backgroundImage: `url(${BgImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/fsk/logo.webp"
              alt="TekRevol"
              className="logo_fsk"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={474}
              height={499}
            />
            <h1>A Fusion of Strategy, Creativity, and Storytelling</h1>
            <div class="banner_playbtn">
              <Link to="https://play.google.com/store/apps/details?id=com.bambamtastic.fsk">
                <StaticImage
                  src="../../../images/case-studies/cmore/play.png"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={159}
                  height={52}
                />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
